import { EnvironmentProviders } from '@angular/core';

import { eagerProvider } from '../util';
import { ViewportFixService } from './viewport-fix.service';
export * from './viewport-fix.service';

export function providePwaViewportFix(): EnvironmentProviders {
  return eagerProvider(ViewportFixService);
}
